///<amd-module name='ExecutionStatus'/>

/**
 * Boolean indicating whether the "Cancel" button has been clicked.
 * null indicates tests have not been ran during this session.
 */
export let cancel: boolean = null;

/** Sets the status of the cancel boolean */
export function setCancelDiagnosticsStatus(cancelBool: boolean): void {
    cancel = cancelBool;
}

export const isLocal = location.hostname === "localhost";
